import React from "react"

import {
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
} from "@mui/material"

import { Link } from "react-router-dom"

import Icon from "@mdi/react"

import { RouteInfo } from "components/commons"

export enum SidebarItemSelectionMode
{
	EXACT, //
	MATCH, //
	NONE, //
}
interface SidebarItemProps
{
	to?: string
	externalHref?: string
	icon?: string
	selected?: SidebarItemSelectionMode
	title?: string

	data?: RouteInfo

	disabled?: boolean
	highlighted?: boolean
}
interface SidebarItemState
{
}
export class SidebarItem extends React.Component<SidebarItemProps, SidebarItemState>
{
	static defaultProps = {
		selected: SidebarItemSelectionMode.MATCH,
		disabled: false,
	}

	constructor(props: SidebarItemProps)
	{
		super(props)
		this.state = {}
	}

	render()
	{
		const to = this.props.to ?? this.props.data?.getPath() ?? "/not-found"
		const externalHref = this.props.externalHref
		const icon = this.props.icon ?? this.props.data?.icon ?? ""
		const title = this.props.title ?? this.props.data?.title ?? "--MISSING--TITLE--"
		const highlightedSx = this.props.highlighted ? {
			backgroundColor: "rgba(255, 255, 255, 0.10)",
			borderLeft: "4px solid #66d9ef",
			"&:hover": {
				backgroundColor: "rgba(255, 255, 255, 0.16)",
			},
		} : undefined

		const currentPage = window.location.pathname
		let isSelected: boolean = false
		if(externalHref === undefined && this.props.selected === SidebarItemSelectionMode.EXACT) {
			isSelected = currentPage === "/"
		} 
		if(externalHref === undefined && this.props.selected === SidebarItemSelectionMode.MATCH) {
			isSelected = currentPage.startsWith(to)
		}

		if(externalHref !== undefined) {
			return (
				<ListItem>
					<ListItemButton
						component="a"
						href={externalHref}
						target="_blank"
						rel="noopener noreferrer"
						selected={false}
						disabled={this.props.disabled}
						sx={highlightedSx}
					>
						<ListItemIcon><Icon path={icon} size={1} /></ListItemIcon>
						<ListItemText primary={title} />
					</ListItemButton>
				</ListItem>
			)
		}

		return (
			<ListItem>
				<ListItemButton component={Link} to={to} selected={isSelected} disabled={this.props.disabled} sx={highlightedSx}>
					<ListItemIcon><Icon path={icon} size={1} /></ListItemIcon>
					<ListItemText primary={title} />
				</ListItemButton>
			</ListItem>
		)
	}
}
